<template>
  <div>
      <div class="d2-mainSlider" ref="homeSlider">
        <div class="d2-mainSlider__cell" v-for="main in main_cover_gamebox" :key="main.key">
          <div class="d2-mainSlider__content boxed">
              <span v-if="lang_gamebox !== 'english'">
                <h1 class="d2-h1" v-if="main[`cont_name_${lang_gamebox}`] !== ''">{{ main[`cont_name_${lang_gamebox}`] }}</h1>
                <h1 class="d2-h1" v-else>{{ main[`cont_name_english`] }}</h1>
              </span>
              <span v-else>
                <h1 class="d2-h1">{{ main[`cont_name_english`] }}</h1>
              </span>
              <div class="d2-rating">
                <star-rating
                :inline="true"
                :star-size="16"
                :read-only="true"
                :increment="0.01"
                active-color="#FFCF00"
                :show-rating="false"
                :border-width="2"
                border-color="#FFCF00"
                :rounded-corners="false"
                inactive-color="transparent"
                :star-points="[
                  23,
                  2,
                  14,
                  17,
                  0,
                  19,
                  10,
                  34,
                  7,
                  50,
                  23,
                  43,
                  38,
                  50,
                  36,
                  34,
                  46,
                  19,
                  31,
                  17
                ]"
                :rating="Number(main.rating)"
              ></star-rating>
              </div>
              <div class="d2-btnContainer">
                <button class="d2-button md " data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(main.id)"><span>{{$t('play')}}</span></button>
              </div>
          </div>
          <div class="d2-mainSlider__bg" v-bind:style="{ 'background-image': 'url(' + main.cover_img + ')' }"></div>
        </div>
      </div>

      <div v-if="$props.main.isLoad === false">
        <svg class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </div>
      <div v-if="$props.main.isLoad === true" class="boxed">
        <div class="d2-sliderRow" v-for="(hot, index) in $props.main.subcategory" :key="index">
          <div class="sliderRow__header">
            <h2 class="d2-h2">
              <span class="text_color">{{ $t("popular") }} - 
                <span v-if="lang_gamebox !== 'english'">{{ hot[`title_${lang_gamebox}`] }}</span>
                <span v-if="lang_gamebox === 'english'">{{ hot.subcategory }}</span>
              </span>
            </h2>
            <div class="right">
              <router-link :to="{ path: 'popular', query: { q: hot.subcategory } }" class="d2-link">{{$t("view_more")}}</router-link>
            </div>
          </div>
          <div class="sliderRow__content">
           <gamebox-slider
              :id="hot.subcategory"
              :slider_ref="'gameSlider'+index"
              :sliderData="$props.main.hotpicks[hot.subcategory]"
              :sliderCategory="hot.category"
              :isLoaded="$props.main.isLoad"
            ></gamebox-slider>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Flickity from "flickity";
import GameBoxSlider from "./GameBoxSlider";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
export default {
  data() {
    return {
      homeSliderOptions: {
        fade: true,
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        cellAlign: "center",
        resize: true
      },
      stageDragging: false,
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },
  components: {
    "gamebox-slider": GameBoxSlider,
    "star-rating": StarRating
  },
  props: ["main"],
  computed: mapGetters([
    "lang_gamebox",
    "country_gamebox",
    "main_cover_gamebox"
    // "hpisLoad_gamebox"
  ]),

  mounted() {
    this.$nextTick(() => {
      this.intiHomeSider();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.intiHomeSider();
    });
  },
  methods: {
    intiHomeSider() {
      if (this.main_cover_gamebox.length == 3) {
        const homeSliderflkty = new Flickity(
          this.$refs.homeSlider,
          this.homeSliderOptions
        );
        homeSliderflkty.on("dragStart", function() {
          this.stageDragging = true;
        });
        homeSliderflkty.on("dragEnd", function() {
          this.stageDragging = false;
        });
      }
    },
    getDetail(id) {
      this.$root.$emit("getDetail", id);
    }
  }
};
</script>

<style scoped lang="scss">
.d2-mainSlider {
  height: 850px;
  .d2-rating {
    margin: 1rem 0px;
  }
  .d2-btnContainer {
    margin-top: 2rem;
  }
  .flickity-page-dots {
    bottom: 15%;
  }
}
.d2-mainSlider__cell {
  width: 100%;
  height: 850px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}

.d2-mainSlider__bg {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.75;
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;
    background: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(5%, rgb(1, 17, 43)),
      color-stop(50%, rgba(255, 255, 255, 0))
    );
    background: linear-gradient(
      0deg,
      rgb(1, 17, 43) 5%,
      rgba(255, 255, 255, 0) 50%
    );
  }
}
.d2-mainSlider__content {
  // margin-left: 15px;
  // max-width: 720px;
  width: 100%;
}
/*##### Arabic layout Styles#####*/
.ar_layout .d2-mainSlider__content {
  text-align: right;
  direction: rtl;
}

/*##### Responsive layout Styles#####*/
@media (max-width: 991px) {
  .d2-mainSlider,
  .d2-mainSlider__cell {
    height: 420px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gamebox/Main.vue